import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';

export interface UploadStepFileResponse {
  job_id: string;
  status: string;
  message?: string;
}

export interface StepFileStatusResponse {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  download_url?: string;
  error?: string;
}

export function uploadStepFile(
  formData: FormData,
): Promise<UploadStepFileResponse> {
  return jwtAxios.post(`/api/step/upload`, formData).then(res => res.data);
}

export function getStepFileStatus(
  jobId: string,
): Promise<StepFileStatusResponse> {
  return jwtAxios.get(`/api/step/status/${jobId}`).then(res => res.data);
}

export function downloadStepFile(jobId: string): Promise<Blob> {
  return jwtAxios.get(`/api/step/download/${jobId}`, {
    responseType: 'blob',
  }).then(res => res.data);
}


